import { render } from "./bindEmail.vue?vue&type=template&id=7fe2bcde&scoped=true"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"

import "./bindEmail.vue?vue&type=style&index=0&id=7fe2bcde&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe2bcde"]])

export default __exports__